module.exports = __webpack_public_path__ + "static/img/kehujiazhi.f5ebf9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/yunwei/kehujiazhi.jpg
// module id = iGGF
// module chunks = 6